import React, { useState, useEffect } from 'react';
import SablonListesi from './SablonListesi';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

const SablonListesiSayfalama = ({ sablonlar, kategoriler, onDuzenle, onSil }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const sablonlarPerPage = 18;

  useEffect(() => {
    setCurrentPage(1);
  }, [sablonlar]);

  const totalPages = Math.ceil(sablonlar.length / sablonlarPerPage);
  const indexOfLastSablon = currentPage * sablonlarPerPage;
  const indexOfFirstSablon = indexOfLastSablon - sablonlarPerPage;
  const currentSablonlar = sablonlar.slice(indexOfFirstSablon, indexOfLastSablon);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <SablonListesi
        sablonlar={currentSablonlar}
        kategoriler={kategoriler}
        onDuzenle={onDuzenle}
        onSil={onSil}
      />
      {totalPages > 1 && (
        <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="Sayfalama">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
            aria-label="Önceki sayfa"
          >
            <ChevronLeftIcon className="h-5 w-5" />
          </button>
          {[...Array(totalPages).keys()].map((number) => {
            const aktif = currentPage === number + 1;
            return (
              <button
                key={number + 1}
                onClick={() => paginate(number + 1)}
                aria-current={aktif ? 'page' : undefined}
                className={`app-num flex h-9 min-w-[2.25rem] items-center justify-center rounded-lg px-2 text-sm font-medium transition-colors ${
                  aktif
                    ? 'bg-gradient-to-b from-slate-700 to-slate-900 text-white shadow-sm'
                    : 'border border-slate-200 bg-white text-slate-600 hover:bg-slate-50'
                }`}
              >
                {number + 1}
              </button>
            );
          })}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
            aria-label="Sonraki sayfa"
          >
            <ChevronRightIcon className="h-5 w-5" />
          </button>
        </nav>
      )}
    </div>
  );
};

export default SablonListesiSayfalama;
